module.exports = {"title":"Televisie uitzending Het Vermoeden","date":"2013-04-01T00:00:00Z","layout":"post","attachment":null,"linktext":null,"body":"<p>Op <strong>24</strong> en <strong>26 april</strong> (herhaling) <strong>2009</strong> was Sylvain De Bleeckere de gast van het televisieprogramma <strong>Het Vermoeden op Ned. 2 (Ikon)</strong>.\nDe uitzending is online te bekijken op <a href=\"http://www.npo.nl/het-vermoeden/12-09-2009/POW_00245630\">Het vermoeden</a>.</p>\n"}


//////////////////
// WEBPACK FOOTER
// ./blog/2015-01-01-TelevisieUitzendingHetVermoeden/index.md
// module id = 963
// module chunks = 0